(() => {
  // app/scripts/product-description.js
  // Tab clicks scroll the matching section into view. Headings must land
  // BELOW the sticky tab strip (and any sticky site header), not under it.
  customElements.define("product-description-component", class productDescription extends HTMLElement {
    constructor() {
      super();
      this.updateStickyTabs = () => {
        const header = this.querySelector(".tab__panel-header");
        if (!header) return;
        const mobile = window.matchMedia("(max-width: 749px)").matches;
        header.classList.toggle("is-stuck", mobile && header.getBoundingClientRect().top <= 0);
      };
      this.onStickyTabsScroll = () => {
        if (this.stickyTabsFrame) return;
        this.stickyTabsFrame = requestAnimationFrame(() => {
          this.stickyTabsFrame = null;
          this.updateStickyTabs();
        });
      };
      this.onTabPointerDown = (e) => {
        if (!window.matchMedia('(max-width: 749px)').matches || !e.target.closest('.tab__panel-header')) return;
        this.tabGesture = { x: e.clientX, y: e.clientY, moved: false };
      };
      this.onTabPointerMove = (e) => {
        if (!this.tabGesture) return;
        if (Math.abs(e.clientX - this.tabGesture.x) > 8 ||
            Math.abs(e.clientY - this.tabGesture.y) > 8) this.tabGesture.moved = true;
      };
      this.onTabPointerEnd = () => {
        if (this.tabGesture?.moved) this.suppressTabClickUntil = Date.now() + 400;
        this.tabGesture = null;
      };
      this.onTabFocus = (e) => {
        const tab = e.target.closest(".tab-content--heading");
        if (tab) this.revealTab(tab);
      };
      this.addEventListener("click", (e) => {
        const { target } = e;
        const link = target.closest(".js-scroll-to");
        if (!link) return;
        if (e.detail !== 0 && Date.now() < (this.suppressTabClickUntil || 0)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        this.setActiveTab(link);
        // Kill hash navigation (href="#tab…") — native jump ignores the
        // sticky tab strip and hides the section H1 under it.
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }
        this.scrollTo(link.dataset.scroll);
      });
      this.openSuperClub = () => {
        const tab = document.querySelector(".tab-superclub");
        if (!tab) return false;
        tab.click();
        return true;
      };
      this.dismissedSuperpointsTips = new WeakSet();
      this.superpointsFocusStyleObserver = null;
      this.clearInjectedSuperpointsOutline = (tip) => {
        if (!tip?.matches?.(".pdp-superpoints-tip")) return;
        if (!tip.style?.getPropertyValue) return;
        const outline = tip.style.getPropertyValue("outline");
        const outlineOffset = tip.style.getPropertyValue("outline-offset");
        if (!outline && !outlineOffset) return;
        // UserWay can add an inline !important blue/orange outline after
        // keyboard focus. Remove only those two inline properties so the
        // theme's accessible white-and-teal focus ring remains authoritative.
        tip.style.removeProperty("outline");
        tip.style.removeProperty("outline-offset");
      };
      this.observeSuperpointsFocusStyle = (tip) => {
        if (!this.superpointsFocusStyleObserver) return;
        if (!tip?.matches?.(".pdp-superpoints-tip")) return;
        this.superpointsFocusStyleObserver.observe(tip, {
          attributes: true,
          attributeFilter: ["style"],
        });
      };
      this.onSuperpointsFocusStyleMutation = (records) => {
        for (const record of records) {
          this.clearInjectedSuperpointsOutline(record.target);
        }
      };
      this.closeSuperpointsTips = (except = null) => {
        document.querySelectorAll(".pdp-superpoints-tip").forEach((tip) => {
          if (tip !== except) tip.setAttribute("aria-expanded", "false");
        });
      };
      this.onDocumentControlClick = (e) => {
        const tip = e.target.closest?.(".pdp-superpoints-tip");
        if (tip) {
          const shouldExpand = tip.getAttribute("aria-expanded") !== "true";
          e.preventDefault();
          e.stopPropagation();
          this.dismissedSuperpointsTips.delete(tip);
          this.closeSuperpointsTips(tip);
          tip.setAttribute("aria-expanded", shouldExpand ? "true" : "false");
          return;
        }

        const superClubTrigger = e.target.closest?.(".scroll_point");
        if (superClubTrigger) {
          e.stopPropagation();
          this.closeSuperpointsTips();
          if (!this.openSuperClub()) return;
          e.preventDefault();
          return;
        }

        // The rewards group sits inside a summary. Its gap and border are not
        // controls, so suppress native details activation without making the
        // wrapper itself interactive.
        const superpointsGroup = e.target.closest?.(".product-points-item");
        if (!superpointsGroup) return;
        e.preventDefault();
        e.stopPropagation();
      };
      this.onDocumentFocusIn = (e) => {
        const tip = e.target.closest?.(".pdp-superpoints-tip");
        if (!tip || e.target !== tip) return;
        this.observeSuperpointsFocusStyle(tip);
        this.clearInjectedSuperpointsOutline(tip);
        if (this.dismissedSuperpointsTips.has(tip)) return;
        if (!tip.matches(":focus-visible")) return;
        this.closeSuperpointsTips(tip);
        tip.setAttribute("aria-expanded", "true");
      };
      this.onDocumentFocusOut = (e) => {
        const tip = e.target.closest?.(".pdp-superpoints-tip");
        if (!tip || e.target !== tip) return;
        if (e.relatedTarget && tip.contains(e.relatedTarget)) return;
        this.dismissedSuperpointsTips.delete(tip);
        tip.setAttribute("aria-expanded", "false");
      };
      this.onDocumentPointerOver = (e) => {
        const tip = e.target.closest?.(".pdp-superpoints-tip");
        if (!tip || (e.relatedTarget && tip.contains(e.relatedTarget))) return;
        this.observeSuperpointsFocusStyle(tip);
        this.clearInjectedSuperpointsOutline(tip);
        if (e.pointerType === "touch" || this.dismissedSuperpointsTips.has(tip)) return;
        this.closeSuperpointsTips(tip);
        tip.setAttribute("aria-expanded", "true");
      };
      this.onDocumentPointerOut = (e) => {
        const tip = e.target.closest?.(".pdp-superpoints-tip");
        if (!tip || (e.relatedTarget && tip.contains(e.relatedTarget))) return;
        this.dismissedSuperpointsTips.delete(tip);
        tip.setAttribute("aria-expanded", "false");
      };
      this.onDocumentClick = (e) => {
        this.closeSuperpointsTips();

        const warrantyTrigger = e.target.closest?.(".sb-warranty-note");
        if (!warrantyTrigger) return;
        const tab = document.querySelector(".tab-warranties");
        if (!tab) return;
        e.preventDefault();
        tab.click();
      };
      this.onDocumentKeydown = (e) => {
        if (e.key !== "Escape") return;
        const expandedTip = document.querySelector(
          '.pdp-superpoints-tip[aria-expanded="true"]'
        );
        if (!expandedTip) return;
        e.preventDefault();
        this.dismissedSuperpointsTips.add(expandedTip);
        this.closeSuperpointsTips();
        expandedTip.focus({ preventScroll: true });
      };
    }

    connectedCallback() {
      this.addEventListener('pointerdown', this.onTabPointerDown, { passive: true });
      window.addEventListener('pointermove', this.onTabPointerMove, { passive: true });
      window.addEventListener('pointerup', this.onTabPointerEnd);
      window.addEventListener('pointercancel', this.onTabPointerEnd);
      window.addEventListener("scroll", this.onStickyTabsScroll, { passive: true });
      window.addEventListener("resize", this.onStickyTabsScroll);
      this.updateStickyTabs();
      this.cleanLegacyDescription();
      if (typeof MutationObserver === "function") {
        this.superpointsFocusStyleObserver = new MutationObserver(
          this.onSuperpointsFocusStyleMutation
        );
        for (const tip of document.querySelectorAll(".pdp-superpoints-tip")) {
          this.observeSuperpointsFocusStyle(tip);
          this.clearInjectedSuperpointsOutline(tip);
        }
      }
      this.setActiveTab(this.querySelector(".tab-content--heading.active"));
      this.querySelector(".tab-links")?.addEventListener("focusin", this.onTabFocus);
      document.addEventListener("click", this.onDocumentControlClick, true);
      document.addEventListener("click", this.onDocumentClick);
      document.addEventListener("keydown", this.onDocumentKeydown);
      document.addEventListener("focusin", this.onDocumentFocusIn);
      document.addEventListener("focusout", this.onDocumentFocusOut);
      document.addEventListener("pointerover", this.onDocumentPointerOver);
      document.addEventListener("pointerout", this.onDocumentPointerOut);
    }

    disconnectedCallback() {
      this.removeEventListener('pointerdown', this.onTabPointerDown);
      window.removeEventListener('pointermove', this.onTabPointerMove);
      window.removeEventListener('pointerup', this.onTabPointerEnd);
      window.removeEventListener('pointercancel', this.onTabPointerEnd);
      this.tabGesture = null;
      window.removeEventListener("scroll", this.onStickyTabsScroll);
      window.removeEventListener("resize", this.onStickyTabsScroll);
      cancelAnimationFrame(this.stickyTabsFrame);
      this.stickyTabsFrame = null;
      this.superpointsFocusStyleObserver?.disconnect();
      this.superpointsFocusStyleObserver = null;
      this.querySelector(".tab-links")?.removeEventListener("focusin", this.onTabFocus);
      document.removeEventListener("click", this.onDocumentControlClick, true);
      document.removeEventListener("click", this.onDocumentClick);
      document.removeEventListener("keydown", this.onDocumentKeydown);
      document.removeEventListener("focusin", this.onDocumentFocusIn);
      document.removeEventListener("focusout", this.onDocumentFocusOut);
      document.removeEventListener("pointerover", this.onDocumentPointerOver);
      document.removeEventListener("pointerout", this.onDocumentPointerOut);
    }

    cleanLegacyDescription() {
      const description = this.querySelector(".tab-content--body--description");
      if (!description) return;

      const contentHeading = description.querySelector(":scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6");
      const productTitle = document.querySelector('meta[property="og:title"]')?.content?.trim();

      // Older catalog entries often repeat a near-identical product title at
      // the start of the description (sometimes with a variant suffix such as
      // "-R"). Remove it only when most normalized title words overlap.
      if (contentHeading && productTitle) {
        const words = (value) => new Set(
          value
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, " ")
            .trim()
            .split(/\s+/)
            .filter(Boolean)
        );
        const headingWords = words(contentHeading.textContent);
        const titleWords = words(productTitle);
        const smallerWordCount = Math.min(headingWords.size, titleWords.size);
        const sharedWordCount = [...headingWords].filter((word) => titleWords.has(word)).length;

        if (smallerWordCount >= 3 && sharedWordCount / smallerWordCount >= 0.75) {
          contentHeading.remove();
        }
      }

      // Keep legacy specification text only when it is the product's sole
      // source of technical data. Once the dedicated Specifications tab has a
      // structured table, the inline "Specifications:" dump is redundant and
      // considerably harder to scan.
      const hasStructuredSpecifications = this.querySelector(
        ".tab-content--body--specifications table tr"
      );
      if (!hasStructuredSpecifications) return;

      const specificationsMarker = [...description.children].find((element) =>
        /^specifications?:?$/i.test(element.textContent.trim())
      );
      if (!specificationsMarker) return;

      let node = specificationsMarker;
      while (node) {
        const next = node.nextSibling;
        node.remove();
        node = next;
      }
      description.classList.add("legacy-description-cleaned");
    }

    setActiveTab(activeTab) {
      if (!activeTab) return;
      activeTab.closest(".tab-links")?.querySelectorAll("a").forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle("active", isActive);
        if (isActive) {
          tab.setAttribute("aria-current", "true");
        } else {
          tab.removeAttribute("aria-current");
        }
      });
      this.revealTab(activeTab);
    }

    revealTab(tab) {
      if (!tab || !window.matchMedia("(max-width: 749px)").matches) return;
      const links = tab.closest(".tab-links");
      const sliderComponent = links?.closest("slider-component");
      const tabs = links ? Array.from(links.querySelectorAll(".tab-content--heading")) : [];
      const index = tabs.indexOf(tab);
      if (index < 0 || !sliderComponent) return;
      const railBounds = sliderComponent.getBoundingClientRect();
      const tabBounds = tab.getBoundingClientRect();
      // Leave an already-visible tab in place instead of shifting the rail.
      if (tabBounds.left >= railBounds.left + 30 &&
          tabBounds.right <= railBounds.right - 30) return;


      // Tiny Slider owns the mobile rail. Align the selected/focused label to
      // a real slide boundary so programmatic SuperClub/Warranty triggers and
      // keyboard focus never leave the important tab hidden under an arrow.
      requestAnimationFrame(() => {
        customElements.whenDefined("slider-component").then(() => {
          sliderComponent.createSlide?.();
          sliderComponent.querySelectorAll(".slider-controls button").forEach((button) => {
            button.removeAttribute("tabindex");
          });
          sliderComponent.goTo?.(index);
        });
      });
    }

    stickyOffset() {
      // Always clear the sticky tab strip + a little breathing room so the
      // section H1 is fully visible under it after a tab click.
      let offset = 12;
      const tabHeader = this.querySelector(".tab__panel-header");
      if (tabHeader) {
        // position:sticky still occupies layout height even when not "stuck";
        // use its height whenever it can cover content at the top.
        offset += Math.ceil(tabHeader.getBoundingClientRect().height);
      }
      // Sticky site header when pinned
      const siteHeader =
        document.querySelector("header.header-sticky") ||
        document.querySelector(".header-sticky") ||
        document.querySelector("sticky-header");
      if (siteHeader) {
        const r = siteHeader.getBoundingClientRect();
        // only count if it occupies the top of the viewport
        if (r.top <= 0 && r.bottom > 0) {
          offset += r.bottom;
        }
      }
      // Desktop sticky product bar (mobile bar is bottom-fixed, not top).
      // Reserve its height whenever the bar EXISTS and is top-fixed, not only
      // when it is currently painted: it reveals itself once the buy box
      // scrolls away, which is exactly what a tab/anchor click causes. Measuring
      // only the visible state left every heading under the bar on the first
      // click from the top of the page.
      const deskSticky = document.querySelector(".product-sticky-desktop");
      if (deskSticky) {
        const cs = window.getComputedStyle(deskSticky);
        if (cs.position === "fixed" && cs.display !== "none") {
          const h = deskSticky.getBoundingClientRect().height || deskSticky.offsetHeight || 0;
          if (h > 0) offset += h;
        }
      }
      return offset;
    }

    scrollTo(selector) {
      if (!selector) return;
      const section = this.querySelector(selector);
      if (!section) return;

      // Selecting Shipping should reveal its answers before measuring the jump.
      // Finish any in-flight collapse so it cannot close an answer afterward.
      section.querySelectorAll(".pdp-shipping details").forEach((details) => {
        const accordion = details.closest("accordion-component")?.Accordion;
        if (accordion) {
          accordion.animation?.cancel();
          accordion.onAnimationFinish(true);
        } else {
          details.open = true;
        }
      });

      // Prefer the section H1/heading so it remains visible after scroll.
      const heading =
        section.querySelector(".tab-content--heading-text") ||
        section.querySelector("h1, h2, h3") ||
        section.firstElementChild ||
        section;

      // Cancel any in-flight rAF scroll from a previous click.
      if (this.run) {
        cancelAnimationFrame(this.run);
        this.run = null;
      }

      // Instant measured scroll (not smooth). Smooth + long upward jumps
      // left Specs/etc headings under the sticky tab bar mid-animation.
      const go = () => {
        const offset = this.stickyOffset();
        const y =
          heading.getBoundingClientRect().top +
          (window.pageYOffset || document.documentElement.scrollTop) -
          offset;
        window.scrollTo(0, Math.max(0, y));
      };
      go();
      // Re-measure after layout/sticky heights settle.
      requestAnimationFrame(() => {
        go();
        requestAnimationFrame(go);
      });
    }
  });
})();
